import { Image } from "antd";
import { withTranslation } from "react-i18next"
import styled from "styled-components";

// Components
import Text from "components/Text";

// Assets
import Background from '../../../../assets/images/ikombackground.jpg';

// Styled
const StyledWall = styled.div`
  position: relative; 
  width: 100%; 
  height: 600px; 
  padding-top: 15px; 
  background-repeat: no-repeat; 
  background-position: center; 
  background-image: ${`url("${Background}")`};
  background-size: cover;
  border-bottom: 1px solid lightgrey;

  @media screen and (max-width: 960px) {
    background-position: bottom;
    background-size: cover;
    height: 400px;
  }
`;

const StyledWallImageWrapper = styled.div`
  width: 200px;
  margin: auto;

  @media screen and (max-width: 960px) {
    width: 150px;
  }

`;

const StyledWallImage = styled(Image)`
  margin-top: 15px;
  border: 10px solid black;
  width: 200px;

  @media screen and (max-width: 960px) {
    width: 150px;
  }
`;

/**
 * RenderWall
 * @param {*} props 
 * @returns 
 */
const RenderWall = (props) => {
  const getContenturl = () => {
    if (!props.selectedMount) {
      if (props.mountsHistory.length > 0) {
        return props.getMountUrl(props.mountsHistory[0].output)
      } else {
        return props.getIrisUrl(props.selectedIris)
      }
    } else if (props.selectedMount.quotation === true) {
      return `${process.env.REACT_APP_S3_FILES_URL}${props.selectedMount.products[0].mount.output}`
    } else {
      return props.getMountUrl(props.selectedMount.output)
    }    
  }

  const handleOnDownloadMount = () => {
    window.open(props.getMountUrl(props.selectedMount.output))
  }

  const relatedEffect = props.selectedMount ? props.effects.find((effect) => effect._id === props.selectedMount._effect) : null;

  return (
    <StyledWall>      
      <StyledWallImageWrapper>
        <StyledWallImage src={getContenturl()} />
      </StyledWallImageWrapper>

      {
        props.selectedMount && relatedEffect && (
          <div 
            style={{ width: '100%', background: '#176b87', bottom: 0, position: 'absolute', cursor: 'pointer', display: 'flex', }}
          >
            <Text color="white" size={14} style={{ padding: 7, display: 'flex', flexDirection: 'row' }} align="left" >
              Montage sélectionné : {relatedEffect.name} 
            </Text>
            <Text color="white" size={12} style={{ padding: 8, marginLeft: 'auto', textDecoration: 'underline' }} onClick={handleOnDownloadMount}>Télécharger</Text>
            <Text color="white" size={12} style={{ padding: 8,  textDecoration: 'underline' }} onClick={() => props.setDisplayUserMountsModal(true)}>Modifier</Text>


          </div>
        )
      }

    </StyledWall>
  )
}

export default withTranslation()(RenderWall);